import { t } from "i18next";
import * as z from "zod";

/**
 * Schéma du formulaire de profil entreprise (`POST /CompanyProfiles/add`) —
 * seul `companyName` est obligatoire (guide §6.2, CompanyProfileDto) ;
 * `incorporationDate` est une date ISO `YYYY-MM-DD` optionnelle.
 *
 * Factory (règle projet) : créé via `createCompanyProfileSchema()` et
 * mémoïsé au niveau composant sur la langue courante — jamais d'instance
 * exportée. `partyId` n'est pas dans le formulaire : il est injecté au
 * submit depuis le contexte (identité courante).
 */
export const createCompanyProfileSchema = () =>
  z.object({
    companyName: z.string().trim().min(1, { message: t("requiredFieldError") }),
    registrationNumber: z.string().trim().or(z.literal("")),
    taxId: z.string().trim().or(z.literal("")),
    legalRepresentativePartyId: z.string().trim().or(z.literal("")),
    incorporationDate: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/, { message: t("invalidFieldError") })
      .or(z.literal("")),
    sectorActivity: z.string().trim().or(z.literal("")),
  });

export type CompanyProfileFormValues = z.infer<
  ReturnType<typeof createCompanyProfileSchema>
>;
